module.exports = __webpack_public_path__ + "img/TalentCenter.1ae40918.png";